import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { verifyToken } from '../utils/token';

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
    return (
        <Route {...rest} render={props => (
            verifyToken() ?
                <Redirect to="/" />
                : <Component {...props} />
        )} />
    );
};

export default PublicRoute;